import { Component, ElementRef, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { DialogComponentContent } from '@toro/common/shared/models/dialogs/DialogComponentContent';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

// tslint:disable-next-line
interface IWithdrawalLoConfirmData {
    value: number | string;
}

@Component({
    selector: 'app-withdrawal-lo-confirm',
    templateUrl: './withdrawal-lo-confirm.component.html',
    styleUrls: ['./withdrawal-lo-confirm.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WithdrawalLoConfirmComponent extends DialogComponentContent {

    public static readonly CONFIRM_LABEL = 'Sim, quero sacar mesmo assim';
    public static readonly CANCEL_LABEL = 'Não, vou aguardar a transferência';

    public logoPath = `/assets/images/${environment.isNewBrand ? 'santander' : 'toro'}-red-black-small.svg`;
    public logoAlt = environment.isNewBrand ? 'Santander Corretora' : 'Toro Investimentos';
    public confirmLabel = WithdrawalLoConfirmComponent.CONFIRM_LABEL;
    public cancelLabel = WithdrawalLoConfirmComponent.CANCEL_LABEL;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public dialogData: IWithdrawalLoConfirmData,
        public element: ElementRef,
        private dialogReference: MatDialogRef<WithdrawalLoConfirmComponent>,
        private store: Store<AppState>,
    ) {
        super(element, '.withdrawal-lo-confirm');
    }

    public ngOnInit() {
        super.ngOnInit();
        this.trackModalOpened();
    }

    /**
     * Cliente insiste no saque manual.
     */
    public confirm() {
        this.trackElementClicked(this.confirmLabel);
        this.close(this.dialogReference, true);
    }

    /**
     * Cliente desiste do saque manual e aguarda a transferência automática.
     */
    public cancel() {
        this.trackElementClicked(this.cancelLabel);
        this.close(this.dialogReference, false);
    }

    private trackModalOpened() {
        this.sendTracking(ActionEventsEnum.MODAL_OPENED, {});
    }

    private trackElementClicked(element: string) {
        this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, { Element: element });
    }

    private sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: event,
                events: {
                    'Product Area Origin': 'Saque',
                    Group: 'Conexão entre contas',
                    Label: 'Comunicação entre Contas ativa',
                    'Time Responsável': 'Tower',
                    ...breakdowns,
                },
            },
        });
    }
}
